import React, { useState } from "react";
import "./Styles.css";
import { FaWhatsapp } from "react-icons/fa";

const faqs = [
  {
    pergunta: "Quanto tempo leva a manutenção?",
    resposta:
      "Normalmente 48 horas para conclusão completa, dependendo do serviço. Podemos priorizar casos emergenciais mediante solicitação.",
  },
  {
    pergunta: "Quais tipos de computadores atendem?",
    resposta:
      "Atendemos desktops e notebooks de todas as marcas e configurações, garantindo suporte completo e seguro.",
  },
  {
    pergunta: "Tem garantia nos serviços?",
    resposta:
      "Sim, todos os serviços possuem 30 dias de garantia. Caso haja qualquer problema, revisamos sem custo adicional.",
  },
  {
    pergunta: "Posso agendar um horário específico?",
    resposta:
      "Sim, trabalhamos com agendamento personalizado. Basta entrar em contato pelo WhatsApp ou formulário.",
  },
  {
    pergunta: "Vocês instalam softwares originais?",
    resposta:
      "Sim, garantimos que todos os softwares são licenciados e originais, evitando problemas futuros de compatibilidade.",
  },
  {
    pergunta: "Fazem backup dos arquivos?",
    resposta:
      "Sim, podemos realizar backup completo antes de qualquer manutenção, garantindo segurança dos seus dados.",
  },
];

export default function Perguntas() {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleFAQ = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <section className="faq-section">
      <h2>Perguntas Frequentes</h2>
      <div className="faq-container">
        {faqs.map((item, index) => (
          <div
            key={index}
            className={`faq-card ${expandedIndex === index ? "expanded" : ""}`}
          >
            <div
              className="faq-question"
              onClick={() => toggleFAQ(index)}
            >
              {item.pergunta}
            </div>
            <div
              className="faq-answer"
              style={{ display: expandedIndex === index ? "block" : "none" }}
            >
              {item.resposta}
            </div>
          </div>
        ))}
      </div>

      {/* Botão WhatsApp corrigido */}
      <a
        href="https://wa.me/5515996879862?text=Ol%C3%A1!%20Vi%20sua%20landing%20page%20e%20quero%20agendar%20um%20servi%C3%A7o%20de%20manuten%C3%A7%C3%A3o."
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-action-center"
      >
        <FaWhatsapp size={20} /> Fale Conosco
      </a>
    </section>
  );
}
